import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import type { AppNotification } from '../models/notification.model';

@Pipe({
  name: 'translateNotification',
  standalone: true,
})
export class TranslateNotificationPipe implements PipeTransform {
  private readonly transloco = inject(TranslocoService);

  transform(notification: AppNotification): string {
    if (!notification?.key) {
      // Fallback for older notifications that might have a message property
      return notification.message || '';
    }

    if (notification.translate === false) {
      return notification.key || '';
    }

    return this.transloco.translate(notification.key, notification.params);
  }
}
